var onboardingPath = 'onboarding';
var selectedServicePath = 'selectedService';
var durabilityPath = 'durability';
var preferencePath = 'preferences';
export var dependencyFieldPaths = [
    "".concat(onboardingPath, ".").concat(selectedServicePath),
    "".concat(onboardingPath).concat(durabilityPath, ".").concat(preferencePath),
];
